<template>
  <section class="s-blog-main" :class="pageClass">
    <BlogSubmenu />
    <div class="blog-content">
      <slot/>
    </div>
    <BlogFooter :is-featured-articles="showFeaturedArticles" />
    <s-modals-container/>
  </section>
</template>

<script setup>
import { useBaseLayout } from './useBaseLayout'
import BlogSubmenu from '/components/BlogSubmenu.vue'
import BlogFooter from '/components/BlogFooter.vue'
import { usePageContext } from "vike-vue/usePageContext"
import { computed } from 'vue'

const { SModalsContainer } = useBaseLayout()
const pageContext = usePageContext()

const showFeaturedArticles = !pageContext.urlPathname.includes('/pulse') && !pageContext.urlPathname.includes('/another-example');

const pageClass = computed(() => {
  const path = pageContext.urlPathname;

  // Exact matches
  if (path === '/pulse') {
    return 'page-blog-home'
  }
  if (path === '/pulse/list') {
    return 'page-blog-list'
  }
  if (path === '/pulse/categories') {
    return 'page-blog-categories'
  }

  // Include matches
  if (path.includes('/pulse/articles')) {
    return 'page-blog-article'
  }
  if (path.includes('/pulse/categories/')) {
    return 'page-blog-category'
  }
  if (path.includes('/pulse/tags/')) {
    return 'page-blog-tags'
  }

  return 'page-blog-default'
});
</script>

<style type="scss">
@import 'baseStyles.scss';
</style>
